import { render } from "./StyleConfig.vue?vue&type=template&id=8e18cf56&scoped=true"
import script from "./StyleConfig.vue?vue&type=script&lang=js"
export * from "./StyleConfig.vue?vue&type=script&lang=js"

import "./StyleConfig.vue?vue&type=style&index=0&id=8e18cf56&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e18cf56"]])

export default __exports__